import toNumber from 'lodash/toNumber';

import { useSettingsErrorsContext } from '../../SettingsErrorContext';
import { TabType } from '../../types';
import { useUserOrgSettings } from '../../UserOrgSettingsContext';

import {
  setRestBreakThresholdHours,
  validateRestBreakThreshold,
  validateConsecutiveWorkDaysLimitThreshold,
} from './helpers/utils';

type UseLaborCompilance = {
  onChangeHandler: (
    fieldName: 'restBreakThreshold' | 'consecutiveWorkDaysLimitThreshold',
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
};

const validators = {
  restBreakThreshold: validateRestBreakThreshold,
  consecutiveWorkDaysLimitThreshold: validateConsecutiveWorkDaysLimitThreshold,
};

const mappers = {
  restBreakThreshold: (value) => setRestBreakThresholdHours(value),
  consecutiveWorkDaysLimitThreshold: toNumber,
};

export const useLaborCompilance = (): UseLaborCompilance => {
  const { onUserOrgSettingsChange } = useUserOrgSettings();
  const { toggleError } = useSettingsErrorsContext();

  const onChangeHandler = (
    fieldName: 'restBreakThreshold' | 'consecutiveWorkDaysLimitThreshold',
    event
  ) => {
    const { value } = event.currentTarget;

    if (validators[fieldName](value)) {
      onUserOrgSettingsChange({ [fieldName]: mappers[fieldName](value) });
      toggleError(TabType.schedule, fieldName, false);
      return;
    }

    toggleError(TabType.schedule, fieldName, true);
    onUserOrgSettingsChange({ [fieldName]: value });
  };
  return { onChangeHandler };
};
